import React from 'react';
import { Svg, Path } from 'react-native-svg';

interface VerifiedBadgeIconProps {
  size?: number;
  color?: string;
}

export default function VerifiedBadgeIcon({ size = 20, color = '#6B9EC2' }: VerifiedBadgeIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path 
        d="M4.57648 5.99149C4.57648 4.97923 5.39666 4.15905 6.40891 4.15824H7.24287C7.72671 4.15824 8.19029 3.96616 8.53389 3.62577L9.11664 3.04225C9.83064 2.32419 10.9912 2.32095 11.7093 3.03415L11.7101 3.03495L11.7174 3.04144L12.3009 3.62496C12.6437 3.96616 13.1081 4.15743 13.592 4.15743H14.4276C15.4398 4.15743 16.2608 4.97842 16.2608 5.99068V6.82382C16.2608 7.30847 16.4521 7.77205 16.7932 8.11569L17.3768 8.69917C18.0948 9.41325 18.0989 10.5738 17.3857 11.2918L16.7941 11.8835C16.4008 12.2768 16.2096 12.7412 16.2096 13.2251V14.0607C16.2096 15.073 15.3894 15.8932 14.3772 15.8932H13.5416C13.057 15.8932 12.5926 16.0844 12.2498 16.4281L11.6663 17.0116C10.9483 17.7264 9.78691 17.7264 9.06891 17.0116L8.48543 16.4281C8.14179 16.0844 7.67821 15.8932 7.19356 15.8932H6.35799C5.34573 15.8932 4.52555 15.073 4.52555 14.0607V13.2251C4.52555 12.7404 4.33428 12.276 3.99064 11.9324L3.40716 11.3489C2.69227 10.6309 2.69227 9.47037 3.40716 8.75225L3.99064 8.16877C4.33347 7.82513 4.52555 7.36155 4.52555 6.87609V5.99149H4.57648Z" 
        fill={color}
      />
      <Path 
        d="M7.92188 10.1017L9.56953 11.7518L12.9637 8.35596" 
        stroke="white" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Svg>
  );
}
